// core
import React from 'react';
import { Link } from 'react-router-dom';

// settings + utils
import Settings from 'config.js';
import Auth from 'services/Auth.js';
import API from 'utils/API.js';
import CSV from 'utils/CSV.js';
import XHR from 'components/lib/swell-ui-0.0.3/utils/XHR';

// lib
import Page from 'pages/shared/Page';
import Spinner from 'components/shared/Spinner';

// shared
import PageHeader from 'components/shared/PageHeader';
import ButtonsToolbar from 'components/shared/ButtonsToolbar';
import FiltersToolbar from 'components/shared/filters/FiltersToolbar';
import SortingToolbar from 'components/shared/SortingToolbar';

import MainHeading from 'components/shared/MainHeading';
import PageDataWrapper from 'pages/shared/PageDataWrapper.js';

// page-specific/etc.
// import KitOrdersList from 'components/kit-orders/details/KitOrdersList';
import SchoolList from 'components/schools/SchoolList';

import TeacherDetails from 'components/teachers/TeacherDetails';

class TeacherViewerPage extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      error: '',

      teacher: null,
      surveys: []
    };

    this.refresh = this.refresh;
  }

  refresh(teacherId) {
    this.setState((prevState) => {
      prevState.teacher = null;

      return prevState;
    }, () => {
      const endpoint = Settings.V3_API_URL + '/teachers/' + teacherId + '?t=' + (new Date()).getTime()
      const controller = XHR.fetch('GET', endpoint, {}, {
        headers: {
          'Authorization': 'Bearer ' + Auth.getToken()
        }
      }, (response, error) => {
        if (error) {
          this.setState((prevState) => {
            prevState.error = error.message + ' while getting teacher';

            return prevState;
          });

          return false;
        }

        if (!response.data.teacher) {
          alert('Cannot get teacher! (no teacher in response)');

          console.error('cannot get teacher');
          console.dir(response);

          return false;
        }

        this.setState((prevState) => {
          prevState.teacher = response.data.teacher;

          return prevState;
        });
      });
    });
  }

  componentDidMount() {
    const { teacherId } = this.props.match.params;

    this.refresh(teacherId);

    // get surveys
    API.call('GET', Settings.V3_API_URL + '/surveys', {}, (response, error) => {
      if (error) {
        console.dir(error);

        this.setState((prevState) => {
          prevState.errors.push({
            message: 'cannot get surveys: ' + error.message
          });

          return prevState;
        });

        return false;
      }

      this.setState({
        fetching: false,

        surveys: response.data && response.data.surveys ? response.data.surveys : []
      });
    });
  }

  componentWillReceiveProps(nextProps) {
    const { teacherId } = nextProps.match.params;

    this.refresh(teacherId);
  }

  render() {
    if (this.state.error) {
      return (
        <div className="container">
          <div className="row">
            <div className="col-12">
              <div className="alert alert-danger">
                <h2>Oh, mamma!</h2>
                <p>{this.state.error}</p>
              </div>
            </div>
          </div>
        </div>
      );
    }

    if (!this.state.teacher) {
      return (
        <div className="container">
          <div className="row">
            <div className="col-12">
              <h2><Spinner message="Carico insegnante..." /></h2>
            </div>
          </div>
        </div>
      );
    }

    if (this.state.teacher) {
      return (
        <div>
          <TeacherDetails teacher={this.state.teacher} surveys={this.state.surveys} />
        </div>
      );
    }
  }
}

export default TeacherViewerPage;



// WEBPACK FOOTER //
// ./src/pages/teachers/TeacherViewerPage.js